import { TipsBankTransferModal } from "../modals/bankTransfer/tips.bankTransferModal.component";
import { TipsPayoutModal } from "../modals/payout/tips.payoutModal.component";
import { TipsSwishPaymentModal } from "../modals/swishPayment/tips.swishPaymentModal.component";
import type { TipPayoutModalsProps } from "./tips.rows.types";

export const TipPayoutModals = (props: TipPayoutModalsProps): JSX.Element => (
  <>
    <TipsPayoutModal
      isOpen={props.selectedPayoutTips.length > 0}
      onClose={props.onClosePayoutModal}
      onSelectBankTransfer={props.onSelectBankTransfer}
      onSelectSwish={props.onSelectSwish}
    />
    <TipsBankTransferModal
      isOpen={props.selectedBankTransferTips.length > 0}
      isSaving={props.isPayoutSaving}
      tips={props.selectedBankTransferTips}
      onClose={props.onCloseBankTransferModal}
      onMarkAsPaidOut={async ({ companyTipIds, payoutType }) => {
        await props.onPayout(companyTipIds, payoutType);
      }}
    />
    <TipsSwishPaymentModal
      isOpen={props.selectedSwishTips.length > 0}
      isSaving={props.isPayoutSaving}
      tips={props.selectedSwishTips}
      onClose={props.onCloseSwishPaymentModal}
      onPayOut={async ({ companyTipIds, payoutType }) =>
        props.onPayout(companyTipIds, payoutType)
      }
    />
  </>
);
